/**
 * Презентационные хелперы дашборда — чистые функции, без React.
 */

import dayjs from 'dayjs';

/** Период метрик: быстрый сегмент (день/неделя/месяц) или свой диапазон. */
export type DashPeriod = 'day' | 'week' | 'month' | {from: string; to: string};

/** Ключ периода для queryKey. */
export const dashPeriodKey = (p: DashPeriod): string =>
  typeof p === 'string' ? p : `${p.from}..${p.to}`;

/** Подпись сегмента «Период» (свой диапазон) или пусто для базовых. */
export const dashRangeLabel = (p: DashPeriod): string =>
  typeof p === 'string'
    ? 'Период'
    : `${dayjs(p.from).format('D MMM')} – ${dayjs(p.to).format('D MMM')}`;

export const DASH_SEGMENTS: {key: 'day' | 'week' | 'month'; label: string}[] = [
  {key: 'day', label: 'День'},
  {key: 'week', label: 'Неделя'},
  {key: 'month', label: 'Месяц'},
];

/** «6,4» / «12,4» — процент с запятой (без знака). */
export const fmtPct = (n: number): string => String(n).replace('.', ',');

/** MRR крупно: 1 284 000 → «1,28» (млн, 2 знака). */
export const fmtMln = (value: number): string => (value / 1_000_000).toFixed(2).replace('.', ',');
